<template>
  <div id="sso">
    MC Remoteにログインしています。
  </div>
</template>

<script>
import firebase from "firebase";
import userService from "../services/user.service";
export default {
  data() {
    return {};
  },
  created() {
    if (this.checkQuery()) {
      this.sso();
    } else {
      alert("erro");
    }
  },
  methods: {
    checkQuery() {
      const query = this.$route.query;
      return (
        query["PORTAL"] !== undefined &&
        query["ID"] !== undefined &&
        query["GMT"] !== undefined &&
        query["SHA"] !== undefined
      );
    },
    sso() {
      const query = this.$route.query;
      console.log("---- sso start");
      this.$store.dispatch("auth/sso", query).then(
        () => {
          console.log("sso +++A");
          let messaging = null;
          if (firebase.messaging.isSupported()) {
            console.log("sso +++B");
            messaging = firebase.messaging();
            messaging
              .getToken({
                vapidKey: `${process.env.VUE_APP_FIREBASE_VAPID_KEY}`,
              })
              .then((currentToken) => {
                console.log("+++C");
                if (currentToken) {
                  console.log(`login currentToken=${currentToken}`);
                  userService.setToken(currentToken);
                  console.log("++OK");

                  this.$router.push({ name: "top" });
                } else {
                  // Show permission request.
                  console.log(
                    "No registration token available. Request permission to generate one."
                  );
                  // Show permission UI.
                  // updateUIForPushPermissionRequired();
                  // setTokenSentToServer(false);
                  this.$router.push({ name: "top" });
                }
              })
              .catch((err) => {
                console.log("An error occurred while retrieving token. ", err);

                this.$router.push({ name: "top" });
                // showToken("Error retrieving registration token. ", err);
                // setTokenSentToServer(false);
              });
          } else {
            this.$router.push({ name: "top" });
          }
        },
        (error) => {
          console.log("ERROR!!!");
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
  },
};
</script>

<style></style>
